import { useCallback, useContext, useState, useEffect } from "react";
import AnouncementTime from "./AnouncementTime";
import styles from "./index.module.scss";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { ANNOUNCEMENT_WATCH_NOW_BTN_CLICK } from "../../AppConstants/AnalyticsEventName";
const AnnouncementBar = () => {
  const { anouncementBar, showAnnouncement, setShowAnnouncement } =
    useContext(ConstantDataContext);
  const { addGAWithUserInfo } = useContext(AnalyticsContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const closeBar = useCallback(() => {
    setShowAnnouncement(false);
    sessionStorage.setItem("announcementShow", true);
  }, [setShowAnnouncement]);

  useEffect(() => {
    // Only run the rotation if we have announcements to display
    if (
      showAnnouncement &&
      anouncementBar &&
      anouncementBar.data &&
      anouncementBar.data.length > 1
    ) {
      const { delay = 2000 } = anouncementBar;

      const rotationTimer = setTimeout(() => {
        setIsAnimating(true);

        setTimeout(() => {
          setCurrentIndex(
            (prevIndex) => (prevIndex + 1) % anouncementBar.data.length
          );
          setShowText(false);
          setIsAnimating(false);
        }, 200);
      }, delay);

      return () => clearTimeout(rotationTimer);
    }
  }, [anouncementBar, showAnnouncement, currentIndex]);

  if (
    !showAnnouncement ||
    !anouncementBar ||
    !anouncementBar.data ||
    anouncementBar.data.length === 0
  ) {
    return null;
  }

  const { data } = anouncementBar;
  const currentAnnouncement = data[currentIndex];

  const {
    messageMobile = "",
    message = "",
    timer = {},
    ctaText = "",
    link = "",
    campaign_id = "",
    type = "",
    enable = false,
    showCTA = false,
  } = currentAnnouncement;

  const handleWatchNowBtn = () => {
    if (!link) {
      return;
    }

    addGAWithUserInfo(ANNOUNCEMENT_WATCH_NOW_BTN_CLICK, {
      announcement_bar_campaign_id: campaign_id,
      messageMobile: messageMobile,
      message: message,
      link: link,
      enable: enable,
      announcement_index: currentIndex,
    });

    closeBar();
    if (type === "link") {
      window.open(link, "_blank");
    } else {
      window.open(link, "_self");
    }
  };

  return (
    <div className={`${styles.container}`}>
      <div
        className={`${styles.timerWrapper} ${
          isAnimating ? styles.slideOut : styles.slideUp
        }`}
        key={`timer-${currentIndex}`}
      >
        {timer && timer.enable ? <AnouncementTime data={timer} /> : null}
      </div>
      <div type="button" className={styles.closeBtn} onClick={closeBar}>
        <img src={require("../../assets/images/closeRed.png")} alt="" />
      </div>
      <div
        className={`d-flex ${styles.textContainer} ${
          isAnimating ? styles.slideOut : styles.slideUp
        }`}
        key={`announcement-${currentIndex}`}
      >
        <div
          onClick={() => {
            if (isMobileDevice && showCTA) {
              handleWatchNowBtn();
            }
          }}
        >
          {isMobileDevice ? messageMobile : message}
        </div>
        {showCTA && (
          <button className={`btn ${styles.btn}`} onClick={handleWatchNowBtn}>
            {ctaText}
          </button>
        )}
      </div>
      {!isMobileDevice && (
        <div
          type="button"
          className={`${styles.closeBtnDesktop} `}
          onClick={closeBar}
        >
          <img src={require("../../assets/images/closeRed.png")} alt="" />
        </div>
      )}
    </div>
  );
};

export default AnnouncementBar;
